import { useEffect, useSyncExternalStore } from 'react';

/**
 * Page titles live in the header bar, not inside the card. Most routes get their
 * title from the path; a route that knows something better (an e-file's form
 * type, a customer's name) sets it here.
 */
let override: string | null = null;
const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useSetPageTitle(title: string | null): void {
  useEffect(() => {
    override = title;
    emit();
    return () => {
      override = null;
      emit();
    };
  }, [title]);
}

export function usePageTitleOverride(): string | null {
  return useSyncExternalStore(
    subscribe,
    () => override,
    () => null,
  );
}
